/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskViolationTrackerViolation } from './ExecRiskViolationTrackerViolation';
import {
    ExecRiskViolationTrackerViolationFromJSON,
    ExecRiskViolationTrackerViolationFromJSONTyped,
    ExecRiskViolationTrackerViolationToJSON,
} from './ExecRiskViolationTrackerViolation';

/**
 * 
 * @export
 * @interface ExecRiskPaginatedViolationTrackerResponse
 */
export interface ExecRiskPaginatedViolationTrackerResponse {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedViolationTrackerResponse
     */
    total?: number;
    /**
     * 
     * @type {Array<ExecRiskViolationTrackerViolation>}
     * @memberof ExecRiskPaginatedViolationTrackerResponse
     */
    results: Array<ExecRiskViolationTrackerViolation>;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskPaginatedViolationTrackerResponse
     */
    schema_version?: string;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedViolationTrackerResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskPaginatedViolationTrackerResponse
     */
    page_size?: number;
}

/**
 * Check if a given object implements the ExecRiskPaginatedViolationTrackerResponse interface.
 */
export function instanceOfExecRiskPaginatedViolationTrackerResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ExecRiskPaginatedViolationTrackerResponseFromJSON(json: any): ExecRiskPaginatedViolationTrackerResponse {
    return ExecRiskPaginatedViolationTrackerResponseFromJSONTyped(json, false);
}

export function ExecRiskPaginatedViolationTrackerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskPaginatedViolationTrackerResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'results': ((json['results'] as Array<any>).map(ExecRiskViolationTrackerViolationFromJSON)),
        'schema_version': !exists(json, 'schema_version') ? undefined : json['schema_version'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
    };
}

export function ExecRiskPaginatedViolationTrackerResponseToJSON(value?: ExecRiskPaginatedViolationTrackerResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': ((value.results as Array<any>).map(ExecRiskViolationTrackerViolationToJSON)),
        'schema_version': value.schema_version,
        'page': value.page,
        'page_size': value.page_size,
    };
}

